import item from './item'

export default {
    namespaced: true,
    modules: {
        item
    }
}